// extracted by mini-css-extract-plugin
module.exports = {"inputTitle":"input-title_inputTitle__h19xu","title":"input-title_title__2wrj1","title2":"input-title_title2__3zcsa"};